import Logo from './Logo';

const Footer = () => {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <footer className="footer">
      <div className="container footer-grid">
        <div className="footer-brand">
          <div className="footer-logo" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <Logo height={100} />
          </div>
          <p>Bold creative. Strategic thinking. Real results.</p>
          <div className="footer-socials">
            <a href="https://www.instagram.com/raddishmedia?igsh=MXd0eGZxY3ZiMjA3aQ==" target="_blank" rel="noreferrer" aria-label="Instagram">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="18" height="18">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                <circle cx="12" cy="12" r="4"/>
                <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
              </svg>
            </a>
            <a href="https://www.linkedin.com/company/raddish-media/" target="_blank" rel="noreferrer" aria-label="LinkedIn">
              <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
                <rect x="2" y="9" width="4" height="12"/>
                <circle cx="4" cy="4" r="2"/>
              </svg>
            </a>
            <a href="https://x.com/Raddishmedia" target="_blank" rel="noreferrer" aria-label="X Twitter">
              <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
          </div>
        </div>

        <div className="footer-col">
          <h4>Services</h4>
          <ul>
            <li>Social Media Management</li>
            <li>Voiceovers</li>
            <li>Photography & Videography</li>
            <li>Video Editing & Graphics</li>
            <li>Promotion Strategy</li>
            <li>Email Marketing</li>
            <li>SEO</li>
            <li>Web Development</li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Company</h4>
          <ul>
            <li onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Home</li>
            <li onClick={() => scrollTo('services')}>Services</li>
            <li onClick={() => scrollTo('about')}>About</li>
            <li onClick={() => scrollTo('process')}>Process</li>
            <li onClick={() => scrollTo('contact')}>Contact</li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Get In Touch</h4>
          <ul>
            <li><a href="mailto:hello@raddishmedia.com">hello@raddishmedia.com</a></li>
            <li><a href="https://www.raddishmedia.com" target="_blank" rel="noreferrer">www.raddishmedia.com</a></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <p>© {new Date().getFullYear()} Raddish Media. All rights reserved.</p>
          <p>Built with ❤️ by Raddish Media</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
